import {
    FETCH_WHOIS_REQUEST,
    FETCH_WHOIS_SUCCESS,
    FETCH_WHOIS_FAILURE,
} from '../actions/types/whois-action-types';

import { combineReducers } from 'redux';

function isLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case FETCH_WHOIS_REQUEST:
            newState = true;
            break;
        case FETCH_WHOIS_SUCCESS:
        case FETCH_WHOIS_FAILURE:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}

function byDomain( state = {}, action ){
    let newState;
    switch( action.type ){
        case FETCH_WHOIS_SUCCESS:
            newState = {
                ...state,
                [action.domain]: action.whois
            };
            break;
        default:
            return state;
    }

    return newState;
}

export default combineReducers( {
    byDomain,
    isLoading,
} );
